export default `
    --trans-gray-000:        #ffffff00;
    --trans-gray-050:        #00000026;
    --trans-gray-100:        rgba(0, 0, 0, 0.54);
    
    --trans-body:         #f8f9fc00;
`;
